import React from 'react';
import { Link } from 'react-router-dom';

interface LogoProps {
  className?: string;
  showText?: boolean;
  textClassName?: string;
}

const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

const Logo: React.FC<LogoProps> = ({ className = '', showText = true, textClassName = '' }) => {
  return (
    <Link to="/" onClick={scrollToTop} className={`flex items-center space-x-2 ${className}`}>
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 32 32" 
        width="32" 
        height="32"
        className="flex-shrink-0 text-blue-600"
      >
        {/* Cible externe */}
        <circle cx="16" cy="16" r="14" fill="none" stroke="currentColor" strokeWidth="2"/>
        {/* Cible moyenne */}
        <circle cx="16" cy="16" r="10" fill="none" stroke="currentColor" strokeWidth="2"/>
        {/* Cible interne */}
        <circle cx="16" cy="16" r="6" fill="none" stroke="currentColor" strokeWidth="2"/>
        {/* Centre de la cible */}
        <circle cx="16" cy="16" r="2" fill="currentColor"/>
      </svg>
      {showText && (
        <span className={`font-bold text-blue-600 hover:text-blue-700 transition-colors ${textClassName}`}>
          Leadsme
        </span>
      )}
    </Link>
  );
};

export default Logo;

